import { useTranslation } from 'react-i18next';
import useCrudMutation from 'hooks/useCrudMutation';
import { documentService } from 'domain/documents/api/documentService';
import { recentDocumentsQueryKey } from 'domain/documents/hooks/useGetRecentDocuments';

export default function useAddRecentDocument() {
  const { t } = useTranslation('genericItem');

  return useCrudMutation({
    mutationFn: documentService.addRecent,
    errorMessage: t('failedToAddRecentDocumentMessage'),
    invalidateKeys: [[recentDocumentsQueryKey]],
  });
}
